import { Appeal } from "../../classes";
// import moment from "moment";
const AppealModule = {
  namespaced: true,
  state: {
    appeals: [],
    appeal: {},
    isFirstWaitingStatus: true,
    waitingStatus: null
  },
  actions: {
    getAppeals: async ({ commit, rootGetters }, payload) => {
      let marketId = payload.marketId ? payload.marketId : rootGetters["markets/getMarketId"]
      try {
        // Only clear appeals if specified in payload
        if (payload.clearExisting) {
          commit("clearAppeals");
        }
        commit("setIsFirstWaitingStatus");
        const data = await Appeal.getAppealsByMarket({ marketId , ...payload});
        commit("setAppeals", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getAppealBetweenDateByMarket: async ({ commit }, formData) => {
      try {
        commit("clearAppeals");
        const data = await Appeal.getAppealBetweenDateByMarket(formData)
        commit("setAppeals", data)
        return data
      } catch (error) {
        throw error
      }
    },
    createAppeal: async ({ dispatch, commit, rootGetters }, payload) => {
      try {
        const newObj = { ...payload, };
        const data = await Appeal.createAppeal(newObj);
        commit("addAppeal", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    getAppeal: async ({ commit }, payload) => {
      try {
        const data = await Appeal.getAppeal({ id: payload.id });
        commit("setAppeal", { appeal: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
    updateAppeal: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const newObj = {
          ...payload,
        };
        const data = await Appeal.updateAppeal(newObj);
        commit("setAppeal", { appeal: data });
        commit("updateAppeals", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    changeStatusAppeal: async ({ commit, rootGetters, dispatch }, payload) => {
      try {
        const newObj = {
          ...payload,
        };
        const data = await Appeal.changeStatusAppeal(newObj);
        commit("setAppeal", { appeal: data });
        commit("updateAppeals", data);
        return data;
      } catch (err) {
        throw err;
      }
    },
    checkWaitingStatus: async ({ commit }, marketId) => {
      try {
        const data = await Appeal.checkWaitingStatus({ id: marketId });
        commit("setWaitingStatus", { waitingStatus: data });
        return data;
      } catch (err) {
        throw err;
      }
    },
  },
  getters: {
    getAppeals: state => state.appeals,
    getWaitingStatusByMarketId: (state) => {
      const appeals = state.appeals || []
      let temp
      if (!state.isFirstWaitingStatus) {
        temp = appeals.find(appeal => appeal.status === 'waiting')
      } else {
        temp = state.waitingStatus
      }
      return temp
    },
    getAppealsSuccess: (state) => {
      return state.appeals.filter(appeal => appeal.status === 'success').sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || [] ;
    },
    getAppealsPending: (state) => {
      return state.appeals.filter(appeal => appeal.status === 'pending').sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || [] ;
    },
    getAppealsWaiting: (state) => {
      return state.appeals.filter(appeal => appeal.status === 'waiting').sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || []  ;
    },
    getAppealsApproved: (state) => {  
      return state.appeals.filter(appeal => appeal.status === 'approved').sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || [] ;
    },
    getAppealsCancelled: (state) => {
      return state.appeals.filter(appeal => appeal.status === 'cancelled').sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt)) || [] ;
    },
  },
  mutations: {
    setAppeal: (state, payload) => {
      state.appeal = payload.appeal;
    },
    setWaitingStatus: (state, payload) => {
      state.waitingStatus = payload.waitingStatus;
    },
    setIsFirstWaitingStatus: (state) => {
      state.isFirstWaitingStatus = false;
    },
    clearAppeals: (state) => {
      state.appeals = [];
    },
    clearAppealsCancelled: (state) => {
      for (let i = state.appeals.length - 1; i >= 0; i--) {
        if (state.appeals[i].status === 'cancelled') {
          state.appeals.splice(i, 1);
        }
      }
    },
    clearAppealsSuccess: (state) => {
      for (let i = state.appeals.length - 1; i >= 0; i--) {
        if (state.appeals[i].status === 'success') {
          state.appeals.splice(i, 1);
        }
      }
    },
    setAppeals: (state, payload) => {
      const existingAppeals = new Map(
        state.appeals.map(appeal => [appeal.objectId, appeal])
      );
      payload.forEach(newAppeal => {
        if (existingAppeals.has(newAppeal.objectId)) {
          const index = state.appeals.findIndex(a => a.objectId === newAppeal.objectId);
          state.appeals.splice(index, 1, newAppeal);
        } else {
          state.appeals.push(newAppeal);
        }
      });

      state.appeals.sort((a, b) => new Date(b.createdAt) - new Date(a.createdAt));
    },
    addAppeal: (state, payload) => {
      state.appeals = [payload, ...state.appeals];
    },
    updateAppeals: (state, payload) => {
      const index = state.appeals.findIndex(appeal => appeal.objectId === payload.objectId);
      if (index !== -1) {
        state.appeals[index] = payload;
        const temp = state.appeals
        state.appeals = []
        state.appeals = temp
      }
    },
    setChatInAppeal: (state, payload) => {
      const index = state.appeals.findIndex(appeal => appeal?.objectId === payload.appeal?.objectId);
      if (index !== -1) {
        const updatedAppeals = [...state.appeals];
        updatedAppeals[index] = {
          ...updatedAppeals[index],
          chat: {
            ...payload.appeal.chat,
            messageCount: 0
          }
        };
        state.appeals = updatedAppeals;
      }
    },
    setReadChat: (state, payload) => {
      const index = state.appeals.findIndex(appeal => appeal?.objectId === payload.appeal?.objectId);
      if (index !== -1) {
        const updatedAppeals = [...state.appeals];
        updatedAppeals[index] = {
          ...updatedAppeals[index],
          chat: {
            ...updatedAppeals[index].chat,
            marketUnreadCount: 0
          }
        };
        state.appeals = updatedAppeals;
      }
    },
    setIncrementMessageCount: (state, payload) => {
      const index = state.appeals.findIndex(appeal => appeal?.objectId === payload.appeal?.objectId);
      if (index !== -1) {
        const updatedAppeals = [...state.appeals];
        updatedAppeals[index] = {
          ...updatedAppeals[index],
          chat: {
            ...updatedAppeals[index].chat,
            messageCount: updatedAppeals[index].chat.messageCount + 1
          }
        };
        state.appeals = updatedAppeals;
      }
    },
    setUpdateMessagesCount: (state, payload) => {
      const index = state.appeals.findIndex(appeal => appeal?.objectId === payload.appeal?.objectId);
      if (index !== -1) {
        const updatedAppeals = [...state.appeals];
        updatedAppeals[index] = {
          ...updatedAppeals[index],
          chat: {
            ...updatedAppeals[index].chat,
            messageCount: updatedAppeals[index].chat.messageCount + payload.message.length
          }
        };
        state.appeals = updatedAppeals;
      }
    }
  },
};
export default AppealModule;
